import { combineReducers, Reducer } from "redux";
import { produce } from "immer";

import { EMPTY_OBJECT } from "@multiweb/reactUtils";
import { createSetRightsInternal } from "./actions";
import { IComponentRightsState, IRemoveRightsForComponents, ISetRightsForComponentsAction, ISetRightsInternal, RightsState } from "./types";

// TODO dořešit výchozí práva, kde má být jaká hodnota
export const DEFAULT_RIGHTS: IComponentRightsState = {
    enabled: true,
    recommended: true,
    postponedRequired: true,
    visible: true,
    required: true,
};

const visible: Reducer<boolean> = (state = DEFAULT_RIGHTS.visible, action) => {
    if (action instanceof ISetRightsInternal) {
        return action.payload.visible ?? state;
    }

    return state;
};

const enabled: Reducer<boolean> = (state = DEFAULT_RIGHTS.enabled, action) => {
    if (action instanceof ISetRightsInternal) {
        return action.payload.enabled ?? state;
    }

    return state;
};

const required: Reducer<boolean> = (state = DEFAULT_RIGHTS.required, action) => {
    if (action instanceof ISetRightsInternal) {
        return action.payload.required ?? state;
    }

    return state;
};

const postponedRequired: Reducer<boolean> = (state = DEFAULT_RIGHTS.postponedRequired, action) => {
    if (action instanceof ISetRightsInternal) {
        return action.payload.postponedRequired ?? state;
    }

    return state;
};

const recommended: Reducer<boolean> = (state = DEFAULT_RIGHTS.recommended, action) => {
    if (action instanceof ISetRightsInternal) {
        return action.payload.recommended ?? state;
    }

    return state;
};

const componentRights: Reducer<IComponentRightsState> = combineReducers({
    visible,
    enabled,
    required,
    postponedRequired,
    recommended,
});

export const reducer: Reducer<RightsState> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof ISetRightsForComponentsAction) {
        return produce(state, (draft) => {
            action.payload.forEach((rightsPayloadForComponent) => {
                const { id } = rightsPayloadForComponent;
                draft[id] = componentRights(state[id], createSetRightsInternal(rightsPayloadForComponent.rights));
            });
        });
    } else if (action instanceof IRemoveRightsForComponents) {
        return produce(state, (draft) => {
            action.payload.forEach((id) => {
                delete draft[id];
            });
        });
    }

    return state;
};
